// import { Controller } from "react-hook-form";
// import { Button } from "reactstrap";
// import React from "react";

// const FileUploadSelfAssesmentRequestor = ({
//   control,
//   name,
//   uploadedFile,
//   allowedFileTypes,
//   uploadClass,
//   uploadWrapClass,
//   disabled,
//   handleRegisterUpload, // Receive handleRegisterUpload function as a prop
// }) => {
//   const handleFileChange = (e) => {
//     const file = e?.target?.files[0];
//     if (file) {
//       handleRegisterUpload(file); // Call handleRegisterUpload function
//     }
//   };

//   const handleDownload = (e, file) => {
//     e.preventDefault();
//     if (file) {
//       const link = document.createElement("a");
//       link.href = file;
//       link.target = "_blank";
//       link.download = "downloadedFile";

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };
//   const isAcceptedFormat = (file) => {
//     return file && allowedFileTypes?.includes(file?.type);
//   };
//   return (
//     <Controller
//       name={name}
//       control={control}
//       defaultValue={null}
//       render={({ field }) => (
//         <div className={`hl-upload-delete-wrap ${uploadWrapClass || ""}`}>
//           <div className="hl-upload-btn-small">
//             {!disabled && (
//               <Button
//                 className={`hl-upload-btn right ${uploadClass || ""}`}
//                 variant="upload"
//                 title="Upload"
//                 onClick={() => {
//                   document.getElementById(name).click();
//                 }}
//               >
//                 <div class="upload mr-0"></div>
//               </Button>
//             )}
//             <input
//               type="file"
//               id={name}
//               style={{ display: "none" }}
//               onChange={(e) => {
                
//                 handleFileChange(e);
//                 field.onChange(e.target.files[0]);
//               }}
//             />
//           </div>
//           <div className="hl-download-btn hl-file-upload-title">
//             <div className="hl-file-title">
//               <span
//                 title={isAcceptedFormat(field.value) ? field.value?.name : ""}
//               >
//                 {isAcceptedFormat(field.value) ? field.value?.name : ""}
//               </span>
//             </div>
//             {uploadedFile && disabled && (
//               <button
//                 className="btn btn-secondary hl-download-btn hl-upload-btn ml-4"
//                 onClick={(e) => handleDownload(e, uploadedFile)}
//                 title="Download"
//               >
//                 <div class="download mr-0"></div>
//                 {/* Download */}
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     />
//   );
// };

// export default FileUploadSelfAssesmentRequestor;
import { Controller } from "react-hook-form";
import { Button } from "reactstrap";
import React from "react";
import Toaster from "../../common/Toaster";

const FileUploadSelfAssesmentRequestor = ({
  control,
  name,
  uploadedFile,
  allowedFileTypes,
  uploadClass,
  uploadWrapClass,
  disabled,
  handleRegisterUpload,
}) => {
  // File validation function
  const validateFile = (file) => {
    // Check for spaces and special characters in filename
    const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
    const hasSpaces = /\s/.test(file.name);

    if (hasSpaces || hasSpecialChars) {
      Toaster.error(
        "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
      );
      return false;
    }

    // Check file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
      return false;
    }

    // Check file type
    if (!allowedFileTypes?.includes(file.type)) {
      Toaster.error(
        "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
      );
      return false;
    }

    return true;
  };

  const handleFileChange = (e, field) => {
    const file = e?.target?.files[0];
    if (file) {
      if (validateFile(file)) {
        handleRegisterUpload(file);
        field.onChange(file);
      } else {
        // Clear the input if validation fails
        e.target.value = '';
        field.onChange(null);
      }
    }
  };

  const handleDownload = (e, file) => {
    e.preventDefault();
    if (file) {
      const link = document.createElement("a");
      link.href = file;
      link.target = "_blank";
      link.download = "downloadedFile";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const isAcceptedFormat = (file) => {
    return file && allowedFileTypes?.includes(file?.type);
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <div className={`hl-upload-delete-wrap ${uploadWrapClass || ""}`}>
          <div className="hl-upload-btn-small">
            {!disabled && (
              <Button
                className={`hl-upload-btn right ${uploadClass || ""}`}
                variant="upload"
                title="Upload"
                onClick={() => {
                  document.getElementById(name).click();
                }}
              >
                <div className="upload mr-0"></div>
              </Button>
            )}
            <input
              type="file"
              id={name}
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, field)}
              accept={allowedFileTypes.join(',')}
            />
          </div>
          <div className="hl-download-btn hl-file-upload-title">
            <div className="hl-file-title">
              <span
                title={isAcceptedFormat(field.value) ? field.value?.name : ""}
              >
                {isAcceptedFormat(field.value) ? field.value?.name : ""}
              </span>
            </div>
            {uploadedFile && disabled && (
              <button
                className="btn btn-secondary hl-download-btn hl-upload-btn ml-4"
                onClick={(e) => handleDownload(e, uploadedFile)}
                title="Download"
              >
                <div className="download mr-0"></div>
              </button>
            )}
          </div>
        </div>
      )}
    />
  );
};

export default FileUploadSelfAssesmentRequestor;